module.exports = __webpack_public_path__ + "static/media/ic_escalera.93a6becf.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_escalera.webp
// module id = 193
// module chunks = 1